import type {FinalData} from './load_data'

export const generateColorsHelp = ($: JQueryStatic, $container: JQuery<HTMLElement>, data: FinalData) => {
  const $colorsHelpBlock = $('<aside class="colors-help-block container"></aside>')

  const colors = [
    {
      status: 'free',
      text: 'Участок свободен',
    },
    {
      status: 'hold',
      text: 'Участок забронирован',
    },
    {
      status: 'sold',
      text: 'Участок продан',
    },
    {
      status: 'discount',
      text: 'Участок по акции',
    },
    {
      status: 'mortgage',
      text: 'Ипотека',
    },
  ]

  if (data.special.length > 0) {
    colors.push({
      status: 'special',
      text: 'Спецпредложение',
    })
  }

  for (const colorInfo of colors) {
    $colorsHelpBlock.append(`<div class="colors-help-block__color">
                                    <span class="colors-help-block__icon colors-help-block__icon--${colorInfo.status}"></span>
                                    <span class="colors-help-block__text">${colorInfo.text}</span>
                                 </div>`)
  }

  $container.after($colorsHelpBlock)
}
